export default "__VITE_ASSET__DIiYf8fO__"